import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {AppbarConfig} from "../../../config";
import {AppbarStateInterface, NavItemInterface, SidebarStateInterface} from "../../../interfaces";

@Injectable({
  providedIn: "root"
})
export class AppbarService {
  private _appbarState = new BehaviorSubject<AppbarStateInterface>(AppbarConfig);

  public setAppbarState(state: AppbarStateInterface) {
    this._appbarState.next(state);
  }

  public toggleSidebarCollapse() {
    const state = this._appbarState.getValue();
    const newState: AppbarStateInterface = {
      ...state,
      sidebarState: {
        ...state.sidebarState,
        collapse: !state.sidebarState.collapse
      }
    };
    this.setAppbarState(newState);
  }

  public setSidebarCollapse(value: boolean) {
    const state = this._appbarState.getValue();
    if (state.sidebarState.collapse === value) {
      return;
    } else {
      this.toggleSidebarCollapse();
    }
  }

  public setSidebarHeader(title?: string, subline?: string, status?: string) {
    const state = this._appbarState.getValue();
    const newState: AppbarStateInterface = {
      ...state,
      sidebarState: {
        ...state.sidebarState,
        title: title ? title : "",
        subline: subline ? subline : "",
        status: status ? status : ""
      }
    };
    this.setAppbarState(newState);
  }

  public setSidebarShowBack(value?: boolean, url?: string) {
    const state = this._appbarState.getValue();
    const newState: AppbarStateInterface = {
      ...state,
      sidebarState: {
        ...state.sidebarState,
        showBack: value,
        backUrl: url
      }
    };
    this.setAppbarState(newState);
  }

  public setSidebarNavItems(items: NavItemInterface[]) {
    const state = this._appbarState.getValue();
    const newState: AppbarStateInterface = {
      ...state,
      sidebarState: {
        ...state.sidebarState,
        navItems: items
      }
    };
    this.setAppbarState(newState);
  }

  public getAppbarState() {
    return this._appbarState.getValue();
  }

  public appStateObservable() {
    return this._appbarState.asObservable();
  }

  public parseRouteConfig(state?: SidebarStateInterface) {
    if (state) {
      this._appbarState.next({...this._appbarState.value, sidebarState: state});
    }
  }
}
